import React from 'react';
import classes from '../index.module.scss';

const ContractingOfficerTableHeader = () => {
  return (
    <tr>
      <th className={`${classes.No_Wrap}`}>
        Name
      </th>
      <th>
        Organization/Department
      </th>
      <th>
        Options
      </th>
    </tr>
  )
}

export default ContractingOfficerTableHeader;